<script>
    import { navigateTo } from 'svelte-router-spa'
    import { name } from '../../store.js'

    function nxt() {
        name.set($name)
        navigateTo('age')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your full name</h1>
        <p>Ilagay ang iyong buong pangalan</p>
        <input type="text" bind:value={$name}>

        {#if $name}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>